<template>
    <div class="text-center">
        <v-dialog
                v-model="modal"
                width="500"
                :persistent="true"
        >
            <v-card>
                <v-card-title
                        class="headline font-weight-light"
                        primary-title
                        dark
                >
                    Activar Cuenta
                </v-card-title>

                <v-card-text>
                    Notamos que aún no activas tu cuenta. Esto es necesario para continuar utilizando nuestra plataforma, es muy simple y solo te tomará algunos segundos.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary darken-1"
                            dark
                            depressed
                            @click="modal=false"
                            :to="{name: 'panel.account.activate'}"
                    >
                        Continuar con la activación
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default{
        props: ['onValidate', 'onAccept'],
        mounted(){
            this.setModalVisibility()
        },
        data(){
          return {
              modal: false
          }
        },
        watch:{
            $route (to, from){
                this.setModalVisibility();
            },
            currentUser(val){
                this.modal = val && !val.active ? true : false
            }
        },
        computed: {
            ...mapState(['currentUser'])
        },
        methods:{
            setModalVisibility(){
                var vm = this
                var visible

                if(vm.$router.currentRoute.name === 'panel.account.activate'){
                    visible = false
                }else{
                    visible = this.currentUser && !this.currentUser.active ? true : false

                }
                this.modal = visible
                if(typeof this.onValidate == 'function'){
                    this.onValidate(visible)
                }

            },
            accept(){
                this.modal = false
                if(typeof this.onAccept == 'function'){
                    this.onAccept()
                }
            }
        }
    }
</script>
